import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { AggregatedPeerFocusViewModel } from './aggregated-peer-focus.model';

export class AggregatedPeerFocusConfiguration extends ReportSectionConfigurationBase {
  typeName = 'AggregatedPeerFocusConfiguration';
  nodataLocalizationKeyName = 'aggregatedPeerFocus';
  readonly reportSection = ReportSection.AggregatedPeerFocus;
  readonly name = 'aggregatedPeerFocus';
  readonly displayName = 'Aggregated Peer Focus';
  readonly applicableReportTypes = [ReportType.PeerOwnershipReport];
  readonly reportViewModelSections = [ReportViewModelSection.PeerOwnershipReport_AggregatedPeerFocus];
  readonly minSize = 1;
  readonly maxSize = 4;
  readonly defaultSize = 3;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'aggregatedPeerFocusOrientation',
      displayName: 'Orientation',
      isSelected: true,
      canConfigure: true,
      type: ReportSectionConfigurationControlType.Text
    },
    {
      name: 'aggregatedPeerFocusTurnover',
      displayName: 'Turnover',
      isSelected: true,
      canConfigure: true,
      type: ReportSectionConfigurationControlType.Text
    },

    {
      name: 'aggregatedPeerFocusStyle',
      displayName: 'Style',
      isSelected: true,
      canConfigure: true,
      type: ReportSectionConfigurationControlType.Text
    }
  ];
}

export interface AggregatedPeerFocusDataBag {
  [ReportViewModelSection.PeerOwnershipReport_AggregatedPeerFocus]: AggregatedPeerFocusViewModel;
}
